<template>
    <div class="pbi-wrapper">
   <div class="pbi-container" id="powerBIcontainer"></div>
    </div>


</template>
<script>
import * as pbi from "powerbi-client";

export default {
  name: "PowerBiEmbed",
  props: {config: Object},
  components: {},
  data: function () {
    return {
      report: null
    };
  },
  computed: {
    getBootstrapConfig() {
      let models = pbi.models

      return {
        type: "report",
        id: undefined,
        embedUrl: undefined,
        accessToken: undefined, // Keep as empty string, null or undefined
        tokenType: models.TokenType.Embed,
        hostname: "https://app.powerbi.com"
      }
    },

    getConfig() {


      const accessToken = this.config.accessToken
      const reportId = this.config.reportId
      // https://app.powerbi.com/reportEmbed?reportId=YOUR_REPORT_ID&groupId=YOUR_WORKSPACE_ID

      var permissions = pbi.models.Permissions.All;
      let models = pbi.models
       var config = {
        type: "report",
        tokenType: pbi.models.TokenType.Embed,
        accessToken: accessToken,
        background: models.BackgroundType.Transparent,
        embedUrl: "https://app.powerbi.com/reportEmbed?reportId=" + reportId,//+ '&groupId=e026bd69-014c-4f1b-83c9-9542382d5da7',
        id: reportId,
        permissions: permissions,
        settings: {
          filterPaneEnabled: true,
          navContentPaneEnabled: true,
        panes: {
          bookmarks: {
            visible: false
          },
          fields: {
            expanded: false
          },
          filters: {
            expanded: false,
            visible: false
          },
          pageNavigation: {
            visible: true,
            position: 1 // 1 is left
          },
          selection: {
            visible: true
          },
          syncSlicers: {
            visible: true
          },
          visualizations: {
            expanded: false
          }
        },
        }
      };

      return config

    }
  },
  methods: {

    async powerBI() {

      // https://app.powerbi.com/reportEmbed?reportId=YOUR_REPORT_ID&groupId=YOUR_WORKSPACE_ID

      var permissions = pbi.models.Permissions.All;
      var config = this.getConfig

      let powerbi = new pbi.service.Service(
          pbi.factories.hpmFactory,
          pbi.factories.wpmpFactory,
          pbi.factories.routerFactory
      );
      var reportContainer = document.getElementById("powerBIcontainer");
      powerbi.reset(reportContainer);
      var report = powerbi.embed(reportContainer, config);
      this.report = report

      await this.report.updateSettings(config)
      this.report.off("loaded");
      this.report.off("rendered");
      this.report.on("error", function () {
        this.report.off("error");
      });
    }
  },
  watch: {
    config(newV) {
      if (newV) {
        this.powerBI();
      }
    }
  },
  mounted() {
    // Bootstrap
  }
}
</script>


<style scoped lang="scss">
.pbi-wrapper {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
}

.pbi-container {
  flex: 1; /* Makes the container stretch */
  width: 100%;
  height: 100%;
}

::v-deep  #powerBIcontainer {
  flex: 1;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;


}

::v-deep  iframe {
  border: 0;
  //border-top: 1px solid red;
}
</style>